import Model from '@/models/Model.js';

export default class RubricBankGroup extends Model {
    static entity = 'rubric_bank_group';

    static modelName = 'RubricBankGroup';

    static primaryKey = ['rubric_bank_id', 'group_id'];

    static fields() {
        return {
            id: this.attr(null),
            rubric_bank_id: this.attr(null),
            group_id: this.attr(null),

            ...super.fields(),

            video: this.belongsTo('rubric_banks', 'rubric_bank_id'),
            group: this.belongsTo('groups', 'group_id'),
        };
    }
}
